/** Colours of the workout screen, shared by its top bar, question card and end screens. */
export const QUIZ_INK = '#161C24';
export const QUIZ_TEXT = '#2E3A46';
export const QUIZ_MUTED = '#4F5B67';
export const QUIZ_BORDER = '#E3E8EE';
export const QUIZ_BLUE = '#2065D1';

export const QUIZ_RIGHT = '#229A16';
export const QUIZ_RIGHT_SOFT = '#F1FCEA';
export const QUIZ_WRONG = '#C4262E';
export const QUIZ_WRONG_SOFT = '#FFF1EE';

/** A white surface on the grey page: the top bar, the question card and the end screens. */
export const QUIZ_SURFACE = {
    bgcolor: '#FFFFFF',
    border: `1px solid ${ QUIZ_BORDER }`,
    borderRadius: '18px',
    boxSizing: 'border-box',
} as const;

/** The two button looks of the workout: the main action in blue, the others outlined. */
export const QUIZ_BUTTON = {
    height: 48, px: 2.5, borderRadius: '12px', font: 'inherit', fontSize: 15, fontWeight: 700, cursor: 'pointer', flexShrink: 0,
    '&:focus-visible': { outline: `2px solid ${ QUIZ_BLUE }`, outlineOffset: 2 },
} as const;

export const QUIZ_PRIMARY_BUTTON = {
    ...QUIZ_BUTTON, px: 3, border: 0, bgcolor: QUIZ_BLUE, color: '#FFFFFF',
    '&:disabled': { bgcolor: '#A9B4C2', cursor: 'not-allowed' },
} as const;

export const QUIZ_SECONDARY_BUTTON = {
    ...QUIZ_BUTTON, border: '1px solid #CFD6DE', bgcolor: '#FFFFFF', color: QUIZ_INK,
} as const;
